const SUCCESS_PARAM = "contact_success";

class ContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("[data-form]");
    this.successMessage = this.querySelector("[data-success]");
    this.errorMessage = this.querySelector("[data-error]");
    this.submitButton = this.querySelector("button[type='submit']");

    if (!this.form) return;

    if (new URLSearchParams(window.location.search).has(SUCCESS_PARAM)) {
      this.showSuccess();
      return;
    }

    this.form.addEventListener("focusout", (event) => {
      if (!event.target.required) return;

      if (!event.target.validity.valid) {
        this.setFieldError(event.target, true);
      }
    });

    this.form.addEventListener("input", (event) => {
      if (event.target.validity.valid) {
        this.setFieldError(event.target, false);
      }

      event.target.classList.remove("indeterminate");
    });

    this.form.addEventListener("change", (event) => {
      event.target.classList.remove("indeterminate");
    });

    this.form.addEventListener("submit", (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.validate()) return;

    this.setLoading(true);
    this.errorMessage.hidden = true;

    try {
      // Salesforce Web-to-Case sends no CORS headers, so the response is opaque
      // and its status is unreadable — a resolved promise only means the request
      // left the browser. Anything beyond that has to be checked in Salesforce.
      await fetch(this.form.action, {
        method: "POST",
        mode: "no-cors",
        body: new URLSearchParams(new FormData(this.form)),
      });

      this.showSuccess({ moveFocus: true });
    } catch (error) {
      this.setLoading(false);
      this.errorMessage.hidden = false;
    }
  }

  setFieldError(field, hasError) {
    field.classList.toggle("error", hasError);

    const errorMessage = field.id && document.getElementById(`${field.id}-error`);

    if (hasError) {
      field.setAttribute("aria-invalid", "true");
      if (errorMessage) field.setAttribute("aria-describedby", errorMessage.id);
    } else {
      field.removeAttribute("aria-invalid");
      field.removeAttribute("aria-describedby");
    }
  }

  // The form carries `novalidate`, so every field is checked here and flagged
  // together rather than the browser stopping at the first invalid one.
  validate() {
    const fields = this.form.querySelectorAll("input, textarea, select");
    let firstInvalid = null;

    fields.forEach((field) => {
      const isValid = field.validity.valid;

      this.setFieldError(field, !isValid);

      if (!isValid && !firstInvalid) {
        firstInvalid = field;
      }
    });

    firstInvalid?.focus();

    return !firstInvalid;
  }

  setLoading(isLoading) {
    this.submitButton.disabled = isLoading;
    this.form.classList.toggle("contact-form__form--loading", isLoading);
  }

  showSuccess({ moveFocus = false } = {}) {
    this.form.hidden = true;
    this.successMessage.hidden = false;

    if (moveFocus) {
      this.successMessage.setAttribute("tabindex", "-1");
      this.successMessage.focus();
    }
  }
}

if (!customElements.get("contact-form")) {
  customElements.define("contact-form", ContactForm);
}
